import api from './api';

export const sequencesApi = {
  list: () => api.get('/api/sequences'),
  create: (data) => api.post('/api/sequences', data),
  getLeadSequences: (leadId) => api.get(`/api/sequences/lead/${leadId}`),
  assign: (leadId, sequenceId) => api.post(`/api/sequences/lead/${leadId}`, { sequence_id: sequenceId }),
  advanceStep: (id) => api.put(`/api/sequences/${id}/step`),
};
